/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ManagedUser } from './ManagedUser';
import {
    ManagedUserFromJSON,
    ManagedUserFromJSONTyped,
    ManagedUserToJSON,
} from './ManagedUser';

/**
 * 
 * @export
 * @interface ManagedUsersResponse
 */
export interface ManagedUsersResponse {
    /**
     * 
     * @type {Array<ManagedUser>}
     * @memberof ManagedUsersResponse
     */
    data?: Array<ManagedUser>;
}

/**
 * Check if a given object implements the ManagedUsersResponse interface.
 */
export function instanceOfManagedUsersResponse(value: object): value is ManagedUsersResponse {
    let isInstance = true;

    return isInstance;
}

export function ManagedUsersResponseFromJSON(json: any): ManagedUsersResponse {
    return ManagedUsersResponseFromJSONTyped(json, false);
}

export function ManagedUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagedUsersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ManagedUserFromJSON)),
    };
}

export function ManagedUsersResponseToJSON(value?: ManagedUsersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ManagedUserToJSON)),
    };
}

